import { Icon, Tag } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import * as React from 'react'
import { InventoryUnit } from '../../types/api'
import '../../styles/design-v2/inventoryunits/inventoryUnitStyles.scss'
import { UprightStyle } from '../../types'
import { DrawerTable } from './DrawerTable'
import { pluralizeFromNumber } from '../../utils/string'
import PrintMediaTicketButton from '../PrintMediaTicketButton'
import { formatDate } from '../../utils'

const style: UprightStyle = {
  tag: { marginLeft: 3 }
}

// See react-table/README.md for column props
const tableColumns = () => {
  return [
    {
      id: 'uid',
      Header: 'UID',
      sortable: true,
      minWidth: 110,
      className: 'table-cell',
      accessor: d => (
        <span title={d.uid} className="cell-text">
          {d.isMedia ? (
            <>
              <PrintMediaTicketButton inventoryUnitId={d.id} />
              {d.uid}
            </>
          ) : (
            d.uid
          )}
        </span>
      )
    },
    {
      id: 'location',
      Header: 'Location',
      sortable: true,
      minWidth: 100,
      className: 'table-cell',
      accessor: d => (
        <span title={d.inventoryLocation?.name} className="cell-text">
          {d.inventoryLocation?.name}
        </span>
      )
    },
    {
      id: 'shelfId',
      Header: 'Shelf ID',
      sortable: true,
      minWidth: 55,
      className: 'table-cell',
      accessor: d => (
        <span title={d.shelfIdentifier} className="cell-text">
          {d.shelfIdentifier}
        </span>
      )
    },
    {
      id: 'supplier',
      Header: 'Supplier',
      sortable: true,
      minWidth: 100,
      className: 'table-cell',
      accessor: d => (
        <span title={d.supplier?.name} className="cell-text">
          {d.supplier?.name}
        </span>
      )
    },
    {
      id: 'warehouseStatus',
      Header: 'Warehouse Status',
      sortable: true,
      minWidth: 110,
      className: 'table-cell',
      accessor: d => d.warehouseStatus
    },
    {
      id: 'createdAt',
      Header: 'Created At',
      sortable: true,
      minWidth: 80,
      className: 'table-cell',
      accessor: d => formatDate(d.createdAt, false, true)
    }
  ]
}

interface Props {
  inventoryUnits: InventoryUnit[]
}

export const InventoryUnitsDetails = ({ inventoryUnits }: Props) => {
  const columns = React.useMemo(() => tableColumns(), [])

  if (!inventoryUnits || inventoryUnits.length === 0) {
    return (
      <div className="inventory-unit-details">
        <div className="drawer-header">
          <Icon icon={IconNames.CUBE} /> Inventory Units
        </div>
        <div className="non-ideal">No inventory units found</div>
      </div>
    )
  }

  return (
    <>
      <div className="inventory-unit-details">
        <div className="drawer-header">
          <Icon icon={IconNames.CUBE} /> Inventory Units
          <Tag minimal round style={style.tag}>
            {inventoryUnits.length}
          </Tag>
        </div>
        <DrawerTable
          tableProps={{ data: inventoryUnits, columns }}
          dataLabel={`Inventory Unit${pluralizeFromNumber(inventoryUnits.length)}`}
          pageSize={12}
        />
      </div>
    </>
  )
}
